var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CChartLine',{attrs:{"datasets":_vm.datasets,"options":_vm.defaultOptions,"labels":_vm.yLabels}})}
var staticRenderFns = []

export { render, staticRenderFns }